export default {
	section_banner: {
		main_title: {
			one: 'Payment System',
		},
		sub_title: {
			one: 'Using JPWorldPay ',
			two: 'API',
		},
	},

	franchaise_inn_lt: {
		title: {
			one: 'Payment',
			two: 'Register A Merchant',
			three: 'Easy Payment',
		},
	},
	franchaise_inn_rt: {
		label: 'Payment',
		title: {
			one: 'Quick',
			two: 'Guide',
		},
	},
	enjoy_shopping_dwn_1st: {
		label: 'Join The Membership',
		title:
			'Please sign up for membership on the JPWorldPay website to access all features securely and easily.',
	},
	enjoy_shopping_dwn_2nd: {
		label: 'Log In',
		title:
			'All of JPWorldPays services can be used after logging in, providing easy access anytime, anywhere.',
	},
	enjoy_shopping_dwn_3rd: {
		label: 'API Issuance',
		title:
			'API issuance is seamless with JPWorldPay. Generate and manage API keys for secure integration.',
	},
	enjoy_shopping_dwn_4th: {
		label: 'Merchant Registration',
		title:
			'You can register your affiliate store in the affiliate menu. Please enter your affiliate store name and ID.',
	},

	easypayment_main: {
		label: 'STEP 01',
		title: {
			one: 'Easy',
			two: 'Payment',
		},
		main_title: 'Type Your Title',
		paragraph:
			'You can use it conveniently with the JPWorldPay payment system.',
		link: {
			one: 'User-Friendly Interface',
			two: 'Seamless Integration',
			three: 'Quick Access',
		},
	},

	easypayment_tab_1st: {
		label: 'Required Parameters',
		paragraph1: {
			one: 'merchant_name',
			two: 'String',
			three: 'Label',
			four: 'Label',
			five: 'Label',
		},
		paragraph2: {
			one: 'merchant_name',
			two: 'String',
			three: 'Label',
			four: 'Label',
			five: 'Label',
		},
	},

	easypayment_tab_2nd: {
		label: 'Tab 2',
		paragraph1: {
			one: 'merchant_name2',
			two: 'String',
			three: 'Label',
			four: 'Label',
			five: 'Label',
		},
		paragraph2: {
			one: 'merchant_name2',
			two: 'String',
			three: 'Label',
			four: 'Label',
			five: 'Label',
		},
	},

	easypayment_tab_3rd: {
		label: 'Tab 3',
		paragraph1: {
			one: 'merchant_name 3',
			two: 'String',
			three: 'Label',
			four: 'Label',
			five: 'Label',
		},
		paragraph2: {
			one: 'merchant_name 3',
			two: 'String',
			three: 'Label',
			four: 'Label',
			five: 'Label',
		},
	},

	easypayment_tab_4th: {
		label: 'Tab 4',
		paragraph1: {
			one: 'merchant_name 4',
			two: 'String',
			three: 'Label',
			four: 'Label',
			five: 'Label',
		},
		paragraph2: {
			one: 'merchant_name 4',
			two: 'String',
			three: 'Label',
			four: 'Label',
			five: 'Label',
		},
	},

	easypayment_mob: {
		label: {
			one: 'Register A Merchant',
			two: 'Easy Payment',
		},
	},

	easy_pay_sec_dwn: {
		option: {
			one: 'Required Parameters',
			two: 'Tab 1',
			three: 'Tab 2',
			four: 'Tab 3',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
